
export const setProfileUpdate = (user) => (dispatch) => {
    
  dispatch({
    type: "PROFILE_UPDATE",
    payload: user,
  });
};
